export default {
  getCalendar(state) {
    return state.calendar;
  },
  getCalendarSelected(state) {
    return state.calendarSelected;
  },
  getCalendars(state) {
    return state.calendars;
  },
};
